var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitStakeHolderData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.name"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.name) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.cnic"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.cnic) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.role"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.role) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("profile.stakeholder.executive_nonexecutive"))
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.type) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.email"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.email) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.address"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.address) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.phone_office"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.phone_office) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.phone_res"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.phone_res) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.phone_cell"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.phone_cell) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.fax"))),
              ]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.formData.fax) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.national_tax_num"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.national_tax) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.share_holding"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.share_holding) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.amount"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$utils.formatMoney(_vm.amount, _vm.defaultCurrency)
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("profile.stakeholder.per_share_holding"))),
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.per_share_holding) },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeStakeHolderModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }